module.exports = __webpack_public_path__ + "img/10.6985178e.jpg";